import experiment from 'experiment';
import { interactions, pinModeSelectors } from '#packages/stateManagement';
import { ResizeGapsScope } from '../resizeGapsScope';
import { createMouseHandler } from '../resizeGapsMouseHandler';

import type { CSSProperties, MouseEvent } from 'react';
import type { Gap } from '../resizeGapsTypes';

export interface GapBoxStateProps {
  gap?: Gap;
  currentHeight?: number;
  positionCSS: CSSProperties;
  isResizing: boolean;
  isVisible: boolean;
}

export const mapStateToProps = (scope: ResizeGapsScope): GapBoxStateProps => {
  const { editorAPI, resizeGapsStore } = scope;
  const editorState = editorAPI.store.getState();

  const gap = resizeGapsStore.getGap();

  const isExperimentOpen = experiment.isOpen('se_mobileStageNewBehaviour');
  const isContainerExist = !!gap?.container;
  const isInZoomMode = editorState.siteScale !== 1;
  const isMobileEditor = editorAPI.isMobileEditor();
  const isDraggingAnotherComp =
    editorState.mouseActions.dragInProgress && !resizeGapsStore.getIsResizing();
  const isInteractionMode =
    interactions.selectors.isInInteractionMode(editorState);
  const isPinMode = pinModeSelectors.isOpen(editorState);

  return {
    gap,
    currentHeight: Math.floor(gap?.layout?.height),
    positionCSS: gap
      ? {
          top: gap.layout.y,
          left: gap.layout.x,
          width: gap.layout.width,
          height: gap.layout.height,
        }
      : {},
    isResizing: resizeGapsStore.getIsResizing(),
    isVisible:
      isExperimentOpen &&
      isMobileEditor &&
      isContainerExist &&
      !isInteractionMode &&
      !isDraggingAnotherComp &&
      !isInZoomMode &&
      !isPinMode,
  };
};

export interface GapBoxDispatchProps {
  startDrag: (e: MouseEvent, gap: Gap) => void;
}

export const mapDispatchToProps = (
  scope: ResizeGapsScope,
): GapBoxDispatchProps => {
  const { editorAPI, resizeGapsStore } = scope;

  return {
    startDrag: (e: MouseEvent, gap: Gap) => {
      e.stopPropagation();
      editorAPI.mouseActions.registerMouseMoveAction(
        createMouseHandler(editorAPI, e, {
          gap,
          afterStart: () => {
            resizeGapsStore.setIsResizing(true);
          },
          afterOn: (deltaY: number) => {
            resizeGapsStore.setGapHeight(gap.layout.height + deltaY);
          },
          afterEnd: () => {
            resizeGapsStore.setIsResizing(false);
          },
        }),
        { event: e },
      );
    },
  };
};
